import { ElementObj } from '../elements/element-obj';
import { Glb } from '../elements/glb';
import { Model } from '../elements/model';
import { SkyView } from '../skyview';
import { collectTimelineLayers } from './collect-timeline-layers';
import { OmittedLayer } from './manifest';

/**
 * Gets the 3D models and DAE files in the frame, which the CAD drawing report leaves out: a DAE
 * file's nodes are moved when it's loaded.
 *
 * @param assetsInFrame The assets that are shown and in the frame.
 */
export function getOmittedModels(assetsInFrame: ElementObj[]): OmittedLayer[] {
  return assetsInFrame
    .filter((asset) => asset instanceof Model || (asset instanceof Glb && asset.isDae()))
    .map((asset) => ({ kind: 'model', name: asset.name, assetId: asset.assetId }));
}

/**
 * Gets what is shown in the frame but can't be in the CAD drawing report: a legacy scan's point
 * cloud and tiled model, and 3D models and DAE files. Legacy drawings that can't be converted are
 * added when they're prepared, a background map that can't be rendered when it's rendered.
 *
 * @param assetsInFrame The assets that are shown and in the frame.
 */
export function getOmittedLayers(skyview: SkyView, assetsInFrame: ElementObj[]): OmittedLayer[] {
  return [...collectTimelineLayers(skyview).omitted, ...getOmittedModels(assetsInFrame)];
}
